import React, { useContext, useEffect, useState } from "react";
import { DiseaseGroupContext } from "../../contexts/diseaseGroupContext";
import { BackButton } from "./BackButton";
import { ModalDialog } from "./ModalDialog";

export const ErrorModal = ({
	show,
	onClose,
	text,
	currentTheme,
	button2,
	button2Click,
}) => {
	const [theme, setTheme] = useState(currentTheme);
	const context = useContext(DiseaseGroupContext);

	useEffect(() => {
		if (theme) {
		} else {
			setTheme(context.theme.primary());
		}
	}, [context, theme]);

	const _text = Array.isArray(text)
		? text
		: [text || "An unknown error has occurred."];

	return (
		<ModalDialog show={show} onClose={onClose}>
			<div
				className={`relative bg-white text-black flex flex-col transition-all transform max-w-sm shadow-lg p-3 sm:p-4 rounded-lg`}
			>
				{_text.map((m, index) => {
					const cls = `${index === _text.length - 1 ? "mt-1 mb-2" : "my-1"} ${
						_text.length === 1 ? "text-center" : "text-left"
					}`;
					return (
						<p key={`errormodal_${index}`} className={`${cls} text-left`}>
							{m}
						</p>
					);
				})}
				<div className="flex justify-around">
					{button2 && (
						<div className="w-32">
							<BackButton
								onClick={button2Click}
								variant="inactive"
								showIcon={false}
								textOverride={button2}
							/>
						</div>
					)}
					<div className="w-32">
						<BackButton
							onClick={onClose}
							variant="active"
							showIcon={false}
							textOverride="OK"
						/>
					</div>
				</div>
			</div>
		</ModalDialog>
	);
};
